/** Raster scale for html2canvas. Divided back out when placing the image on the PDF page. */
export const LIBRARY_CARD_PDF_CAPTURE_SCALE = 3;

export function libraryCardPdfImageRect(input: {
  canvasWidth: number;
  canvasHeight: number;
  captureScale: number;
  pageWidthMm: number;
  pageHeightMm: number;
}): { x: number; y: number; width: number; height: number } {
  const scale = input.captureScale > 0 ? input.captureScale : 1;
  const widthMm = ((input.canvasWidth / scale) * 25.4) / 96;
  const heightMm = ((input.canvasHeight / scale) * 25.4) / 96;
  const fit = Math.min(input.pageWidthMm / widthMm, input.pageHeightMm / heightMm, 1);
  const width = widthMm * fit;
  const height = heightMm * fit;
  return {
    x: (input.pageWidthMm - width) / 2,
    y: (input.pageHeightMm - height) / 2,
    width,
    height,
  };
}
